
import { defineComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';
import TournamentCard from './TrendingTournaments/TournamentCard.vue';
import EndedTournamentCard from './TrendingTournaments/EndedTournamentCard.vue';
import LoadingCard from './TrendingTournaments/LoadingCard.vue';
export default defineComponent({
  name: 'trending-tournaments',
  components: { TournamentCard, EndedTournamentCard, LoadingCard },
  data(){
    return {
         loading: true,
    }
  },
  computed: {
    ...mapGetters({
        endedTournaments: 'tournament/getEndeds',
        trendingTournaments: 'tournament/getTrendings',
    })
  },
  async created(){
    this.loading = true;
    await this.loadTournaments();
    this.loading = false;
  },
  methods:{
    ...mapActions({ 
      loadTournaments:'tournament/list', // load trending and past
    }),
  }
});
